import { render, staticRenderFns } from "./BaseGeneralInfo.vue?vue&type=template&id=03fd462e&scoped=true&"
import script from "./BaseGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./BaseGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseGeneralInfo.vue?vue&type=style&index=0&id=03fd462e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fd462e",
  null
  
)

export default component.exports